import CustomDialog from 'components/CustomDialog';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import React, { useState } from 'react';
import styled from 'styled-components';
import api from 'api/call';
import useDialog from 'components/ConfirmDialog/useDialog';
import { useDispatch } from 'react-redux';
import { APPLICATION_LIST_REFRESH } from 'store/key';
import CustomDatePicker from 'components/Input/CustomDatePicker';
import { SITE_REMOVED } from 'utility/frontendMessage';

const SLayout = styled.div``;

const RemoveSiteModal = ({ isShow, onCancel = () => null, row }) => {
    const [error, setError] = useState('');
    const [site, setSite] = useState('');
    const [endEffectiveDate, setEndEffectiveDate] = useState(Date.now());
    const [isLoading, setLoading] = useState(false);
    const showDialog = useDialog();
    const dispatch = useDispatch();
    const [sites] = useState(
        row.siteResponseList.map((item) => {
            return {
                key: item.id,
                display: `Site (${item.code})`,
            };
        }),
    );

    const cancel = () => {
        if (!isLoading) {
            onCancel();
        }
    };

    const onSubmit = () => {
        if (site !== -1) {
            setLoading(true);
            api.application
                .removeSite(site, new Date(endEffectiveDate))
                .then((res) => {
                    setTimeout(() => {
                        showDialog({
                            description: SITE_REMOVED,
                            disableCancelButton: true,
                        });
                    }, 100);

                    dispatch({
                        type: APPLICATION_LIST_REFRESH,
                    });
                })
                .finally(() => {
                    setLoading(false);
                    onCancel();
                });
        }
    };

    return (
        <SLayout>
            <CustomDialog
                title={'Remove site from application'}
                isShow={isShow}
                loading={isLoading}
                onCancel={cancel}
                onConfirm={async () => {
                    if (Object.keys(row.siteResponseList).length <= 1) {
                        return setError(`Application should contains at least one study site`);
                    }

                    onSubmit();
                }}
            >
                <div style={{ marginTop: 10 }}>
                    Please Select the site
                    <div style={{ marginTop: 10 }}>
                        <CustomOutlineSelect
                            isRequired
                            choices={sites}
                            value={site}
                            disabled={isLoading}
                            onChange={(e) => {
                                setSite(e.target.value);
                            }}
                        />
                    </div>
                    <div style={{ marginTop: 30 }}>
                        <CustomDatePicker
                            name={'endEffectiveDate'}
                            label={'End Effective Date'}
                            value={endEffectiveDate}
                            maxDate={Date.now()}
                            onChange={(date) => {
                                setEndEffectiveDate(date);
                            }}
                        />
                    </div>
                    {error && <div style={{ color: 'red', marginTop: 10 }}>{error}</div>}
                </div>
            </CustomDialog>
        </SLayout>
    );
};

export default RemoveSiteModal;
